module.exports = __webpack_public_path__ + "img/Efdot-Hat-01@2x.3334dafa.jpg";